<template>
  <div class="other-regions-container">
    <div class="d-flex flex-column align-items-center regions-header" :class="isPhone ? '' : 'pt-5'">
      <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class="mb-0 text-center">Ailleurs</p>
      <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">Autrement</p>
      <p class="text-center" :class="isPhone ? 'merriweather-light-18 mb-1' : 'merriweather-light-24 mb-1'">Nos destinations à travers le monde, entre découvertes et <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">privilèges rares</span></p>
    </div>

    <div class="tabs-container pt-4">
      <div class="destination-tabs">
        <button
          v-for="destination in otherDestinations"
          :key="destination.id"
          @click="selectDestination(destination)"
          :class="['destination-tab', { active: selectedDestination && selectedDestination.id === destination.id }]"
          class="raleway-bold-p15"
        >
          {{ destination.name }}
        </button>
      </div>
    </div>

    <div class="slider-wrapper-regions position-relative w-100" v-if="!isPhone">
      <slither-slider class="slither-slider" :options="{numberOfSlides: 3,
                                  dots: false,
                                  controls: true}">
        <template v-for="(region, index) in filteredRegions">
          <div class="col-grid-region">
            <div class="col-grid-region-card" @click="goToRegion('/destination/'+ region.slug)">
              <div class="zoom-img-container">
                <img :src="region.photo" :alt="region.name" class="zoom-img">
              </div>
              <a class="merriweather-bold-p16">
                <p class="region-name text-center no-translate">{{ region.name }}</p>
              </a>
            </div>
          </div>
        </template>
        <template slot="previous">
          <div class="circle-icon previous-slide-button">
            <img src="../../images/arrow-left.svg" alt="Previous" />
          </div>
        </template>
        <template slot="next">
          <div class="circle-icon next-slide-button">
            <img src="../../images/arrow-right.svg" alt="Next" />
          </div>
        </template>
      </slither-slider>
    </div>

    <div v-else class="regions-flex-container">
      <div class="regions-scroll-wrapper">
        <div
          v-for="(region, index) in filteredRegions"
          :key="index"
          class="region-card-phone"
          @click="goToRegion('/destination/'+ region.slug)"
        >
          <div class="zoom-img-container">
            <img :src="region.photo" :alt="region.name" class="zoom-img">
          </div>
          <a class="merriweather-bold-p16">
            <p class="region-name text-center no-translate">{{ region.name }}</p>
          </a>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center w-100">
      <button class="hortense-btn-primary text-uppercase" :class="isPhone ? 'mx-5' : ''" @click="goToRegion('/destination/'+ selectedDestination.slug)">{{ selectedDestination ? ctaTextMap[selectedDestination.name] || 'Découvrir' : 'Découvrir les destinations' }}</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OtherRegions',
  props: {
    destinations: Array
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      selectedDestination: null,
      ctaTextMap: {
        'Océan Indien': 'Découvrir l\'océan indien',
        'Caraïbes': 'Découvrir les caraibes',
        'Afrique': 'Découvrir l\'afrique',
        'Europe': 'Découvrir l\'europe'
      }
    }
  },
  computed: {
    otherDestinations() {
      const destinations = this.destinations
        .filter(dest => !['FRANCE'].includes(dest.name.toUpperCase()))
        .map(dest => ({
          ...dest,
          regions: [...(dest.regions || [])]
        }));

      const europeIndex = destinations.findIndex(
        d => d.name && d.name.toUpperCase() === 'EUROPE'
      );

      const italyRegion = {
        name: 'Italie',
        slug: 'italie',
        photo: 'https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg',
        get_lodgings: [1]
      };

      if (europeIndex === -1) {
        destinations.push({
          id: 'europe-static',
          name: 'Europe',
          slug: 'europe',
          regions: [italyRegion]
        });
      } else {
        const existingNames = new Set((destinations[europeIndex].regions || []).map(r => r.name));
        if (!existingNames.has('Italie')) {
          destinations[europeIndex].regions = [
            italyRegion,
            ...(destinations[europeIndex].regions || [])
          ];
        }
      }

      return destinations;
    },
    filteredRegions() {
      if (this.selectedDestination && this.selectedDestination.regions) {
        return this.selectedDestination.regions.filter(x=> x.photo && x.get_lodgings && x.get_lodgings.length > 0);
      }
      return this.otherDestinations.length > 0 ? this.otherDestinations[0].regions.filter(x=> x.photo && x.get_lodgings && x.get_lodgings.length > 0) : [];
    }
  },
  mounted() {
    if (this.otherDestinations.length > 0) {
      this.selectedDestination = this.otherDestinations[0];
    }
  },
  methods: {
    goToRegion(url) {
      window.open(url, '_blank');
    },
    selectDestination(destination) {
      this.selectedDestination = destination;
    }
  }
}

</script>
<style lang="scss" scoped>

.tabs-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.destination-tabs {
  display: flex;
  column-gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 100%;
}

.destination-tab {
  padding: 12px 0;
  border: none;
  background-color: transparent;
  color: #524F4FDD;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    color: #000000;
  }

  &.active {
    color: #000000;
    border-bottom: 2px solid #3B6152;
  }
}

.slider-wrapper {
  position: relative;
  width: 100%;
}

.slither-slider {
  padding: 40px 200px 40px 200px;
  width: 100% !important;
}

.circle-icon {
  width: 35px;
  height: 35px;
  border: 1px solid black;
  background: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  img {
    width: 20px;
  }
}

.previous-slide-button {
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
  color: white;
  z-index: 10;
}

.next-slide-button {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translateY(-50%);
  color: white;
  z-index: 10;
}

.col-grid-region {
  padding: 10px;
}
.col-grid-region-card {
   position: relative;
   cursor: pointer;
   overflow: hidden;

   .zoom-img {
     width: 100%;
     height: 400px;
     object-fit: cover;
     display: block;
   }

   .region-name {
     position: absolute;
     bottom: 0;
     left: 0;
     right: 0;
     margin: 0;
     padding: 30px;
     background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
     color: white;
     letter-spacing: 1px;
     text-transform: uppercase;
   }
 }

.regions-flex-container {
  width: 100%;
  display: flex;
  justify-content: start;
  padding: 15px 0;
}

.regions-scroll-wrapper {
  display: flex;
  overflow-x: scroll;
  width: 100%;
  height: 337px;
  gap: 10px;
  padding: 10px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;

    &:hover {
      background: #555;
    }
  }
}

.region-card-phone {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
  width: 260px;
  height: 315px;

  .zoom-img-container {
    width: 100%;
    height: 100%;
  }

  .zoom-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .region-name {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    padding: 20px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
    color: white;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 14px;
  }
}


</style>